/**
 * GreatMighty Luxury Theme JavaScript
 * Handles AJAX Cart Drawer, Modals, Quantity Controls, and Interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initMobileDrawer();
  initAjaxAddToCart();
  initHeaderScroll();
  initScrollAnimations();
  fetchAndUpdateCart(); // Sync cart badges, drawer content, and button in-bag states on load
});

// Scroll state for header glassmorphism
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
}

// Cart Drawer Handlers
function initCartDrawer() {
  const backdrop = document.getElementById('CartDrawerBackdrop');
  const panel = document.getElementById('CartDrawerPanel');
  const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
  const openBtns = document.querySelectorAll('[data-cart-drawer-trigger]');

  window.openCartDrawer = function() {
    if (backdrop && panel) {
      backdrop.classList.add('is-open');
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      fetchAndUpdateCart();
    }
  };

  window.closeCartDrawer = function() {
    if (backdrop && panel) {
      backdrop.classList.remove('is-open');
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.openCartDrawer();
  }));

  closeBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.closeCartDrawer();
  }));

  if (backdrop) {
    backdrop.addEventListener('click', window.closeCartDrawer);
  }
}

// Mobile Menu Drawer
function initMobileDrawer() {
  const backdrop = document.getElementById('MobileMenuBackdrop');
  const panel = document.getElementById('MobileMenuPanel');

  window.openMobileMenu = function() {
    if (backdrop && panel) {
      backdrop.classList.add('is-open');
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeMobileMenu = function() {
    if (backdrop && panel) {
      backdrop.classList.remove('is-open');
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  const triggers = document.querySelectorAll('[data-mobile-menu-trigger]');
  triggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    window.openMobileMenu();
  }));

  const closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
  closeBtns.forEach(c => c.addEventListener('click', (e) => {
    e.preventDefault();
    window.closeMobileMenu();
  }));

  if (backdrop) {
    backdrop.addEventListener('click', window.closeMobileMenu);
  }
}

// Luxury Vector SVG Icons for dynamic UI states
const THEME_ICONS = {
  check: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle; display:inline-block; margin-right:4px;" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>',
  bag: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle; display:inline-block; margin-right:4px;" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  sparkle: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#B87979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle; display:inline-block; margin-right:4px;" aria-hidden="true"><path d="M12 4l2.5 5.5L20 12l-5.5 2.5L12 20l-2.5-5.5L4 12l5.5-2.5L12 4z" fill="#B87979" fill-opacity="0.2"/></svg>'
};

// Update all Add to Bag buttons to reflect current cart state
function updateCartButtonStates(cart) {
  if (!cart || !cart.items) return;
  const inCartVariantIds = new Set(cart.items.map(item => String(item.variant_id)));
  const inCartProductIds = new Set(cart.items.map(item => String(item.product_id)));

  document.querySelectorAll('.add-to-bag-btn').forEach(btn => {
    // If this button is actively playing the success pulse animation, don't interrupt it
    if (btn.classList.contains('btn-added-animate')) return;

    const variantId = btn.getAttribute('data-variant-id');
    const productId = btn.getAttribute('data-product-id');
    const span = btn.querySelector('span') || btn;

    const isMatch = (variantId && inCartVariantIds.has(String(variantId))) ||
                    (!variantId && productId && inCartProductIds.has(String(productId)));

    if (isMatch) {
      btn.classList.add('is-in-bag');
      span.innerHTML = THEME_ICONS.check + 'Added in Bag';
    } else {
      btn.classList.remove('is-in-bag');
      if (btn.closest('.main-product-section')) {
        span.innerHTML = THEME_ICONS.bag + 'Add to Shopping Bag';
      } else {
        span.innerHTML = 'Add to Bag';
      }
    }
  });
}

// AJAX Add to Cart
function initAjaxAddToCart() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    const qInput = form.querySelector('input[name="quantity"]');
    if (qInput && qInput.hasAttribute('max') && qInput.getAttribute('max') !== '') {
      const maxVal = parseInt(qInput.getAttribute('max'), 10);
      const currentVal = parseInt(qInput.value, 10) || 1;
      if (maxVal > 0 && currentVal > maxVal) {
        qInput.value = maxVal;
      }
    }

    const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('.add-to-bag-btn');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    const btnSpan = submitBtn ? (submitBtn.querySelector('span') || submitBtn) : null;

    if (submitBtn) {
      submitBtn.disabled = true;
      if (btnSpan) btnSpan.innerHTML = 'Adding...';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      if (res.ok) {
        // Sync cart drawer & count badge in background
        const cart = await fetchAndUpdateCart();

        // Animate the button smoothly to confirm addition
        if (submitBtn) {
          submitBtn.classList.add('btn-added-animate', 'is-in-bag');
          if (btnSpan) btnSpan.innerHTML = THEME_ICONS.check + 'Added to Bag!';

          // Animate header cart badge
          const badges = document.querySelectorAll('.cart-count-badge');
          badges.forEach(b => {
            b.classList.remove('badge-animate');
            void b.offsetWidth; // trigger reflow
            b.classList.add('badge-animate');
          });

          // Transition to stable Added in Bag state after brief confirmation pulse
          setTimeout(() => {
            submitBtn.classList.remove('btn-added-animate');
            if (btnSpan) btnSpan.innerHTML = THEME_ICONS.check + 'Added in Bag';
            submitBtn.disabled = false;
          }, 1100);
        }

        // NOTE: Cart drawer sheet is intentionally NOT opened as per user specification!
      } else {
        const error = await res.json();
        alert(error.description || 'Could not add product to cart.');
        if (submitBtn) {
          submitBtn.disabled = false;
          if (btnSpan) btnSpan.innerHTML = originalText;
        }
      }
    } catch (err) {
      console.error('Error adding to cart:', err);
      if (submitBtn) {
        submitBtn.disabled = false;
        if (btnSpan) btnSpan.innerHTML = originalText;
      }
    }
  });
}

// Update Cart Drawer & Badges UI Live
function updateCartUI(cart) {
  if (!cart) return;

  // Update cart badge counts
  const countBadges = document.querySelectorAll('.cart-count-badge');
  countBadges.forEach(badge => {
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  // Update Drawer Contents
  const itemsContainer = document.getElementById('CartDrawerItems');
  const subtotalEl = document.getElementById('CartDrawerSubtotal');
  const emptyEl = document.getElementById('CartDrawerEmpty');
  const footerEl = document.getElementById('CartDrawerFooter');
  const shippingProgressEl = document.getElementById('FreeShippingProgressBar');
  const shippingTextEl = document.getElementById('FreeShippingText');

  if (!itemsContainer) return;

  // Format price in Indian Rupee format
  const formatMoney = (cents) => '₹' + (cents / 100).toLocaleString('en-IN');
  const thresholdCents = 49900; // Free shipping threshold ₹499

  // Always keep Free Shipping Progress Bar & Text synced
  if (shippingProgressEl && shippingTextEl) {
    if (!cart.item_count || cart.item_count === 0 || !cart.total_price || cart.total_price === 0) {
      shippingProgressEl.style.width = '0%';
      shippingTextEl.innerHTML = `${THEME_ICONS.sparkle}<span>Orders above <strong>₹499</strong> get <strong>FREE Luxury Shipping!</strong></span>`;
    } else {
      const progress = Math.min(100, (cart.total_price / thresholdCents) * 100);
      shippingProgressEl.style.width = progress + '%';
      if (cart.total_price >= thresholdCents) {
        shippingTextEl.innerHTML = `${THEME_ICONS.sparkle}<span>You unlocked <strong>FREE Shipping!</strong></span>`;
      } else {
        const remaining = thresholdCents - cart.total_price;
        shippingTextEl.innerHTML = `${THEME_ICONS.sparkle}<span>Add <strong>${formatMoney(remaining)}</strong> more to get <strong>FREE Shipping!</strong></span>`;
      }
    }
  }

  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price || 0);
  }

  if (cart.item_count === 0) {
    if (emptyEl) emptyEl.style.display = 'block';
    if (itemsContainer) {
      itemsContainer.style.display = 'none';
      itemsContainer.innerHTML = '';
    }
    if (footerEl) footerEl.style.display = 'none';
  } else {
    if (emptyEl) emptyEl.style.display = 'none';
    if (itemsContainer) itemsContainer.style.display = 'block';
    if (footerEl) footerEl.style.display = 'block';

    // Render Item rows with smooth interactive buttons
    itemsContainer.innerHTML = cart.items.map(item => {
      const imageUrl = (item.featured_image && item.featured_image.url) ? item.featured_image.url : (item.image || '');
      return `
        <div class="cart-item-row" style="display:flex; gap:1rem; padding:1rem 0; border-bottom:1px solid #F3CDD3;" data-key="${item.key}">
          <img src="${imageUrl}" alt="${item.title}" style="width:70px; height:85px; object-fit:cover; border-radius:12px; background:#fff; border:1px solid #F8DEE3;" />
          <div style="flex:1;">
            <h4 style="font-size:0.875rem; font-weight:700; color:#190B28; line-height:1.2; margin-bottom:0.25rem;">${item.product_title}</h4>
            ${item.variant_title ? `<p style="font-size:0.75rem; color:#897B90; margin-bottom:0.35rem;">${item.variant_title}</p>` : ''}
            <div style="font-size:0.875rem; font-weight:700; color:#462A68;">${formatMoney(item.final_line_price)}</div>
            
            <div style="display:flex; align-items:center; justify-content:space-between; margin-top:0.5rem;">
              <div style="display:inline-flex; align-items:center; border:1px solid #D893A2; border-radius:9999px; background:#fff; padding:2px 8px; gap:8px;">
                <button type="button" onclick="updateItemQuantity('${item.key}', ${item.quantity - 1}, this)" style="font-weight:bold; color:#2E1A47; padding:0 4px; background:none; border:none; cursor:pointer;" aria-label="Decrease quantity">-</button>
                <span style="font-size:0.8rem; font-weight:600;">${item.quantity}</span>
                <button type="button" onclick="updateItemQuantity('${item.key}', ${item.quantity + 1}, this)" style="font-weight:bold; color:#2E1A47; padding:0 4px; background:none; border:none; cursor:pointer;" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="cart-item-remove-btn" onclick="updateItemQuantity('${item.key}', 0, this)" aria-label="Remove item">
                Remove
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  // Update all Add to Bag buttons across the page
  updateCartButtonStates(cart);
}

// Fetch Cart & Update UI Live
async function fetchAndUpdateCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartUI(cart);
    return cart;
  } catch (e) {
    console.error('Error fetching cart:', e);
    return null;
  }
}

// Update Cart Item Quantity with instant animation & UX feedback
window.updateItemQuantity = async function(key, quantity, triggerBtn) {
  const row = document.querySelector(`.cart-item-row[data-key="${key}"]`);

  // Instant UX Feedback
  if (quantity === 0) {
    if (row) {
      const removeBtn = triggerBtn || row.querySelector('.cart-item-remove-btn');
      if (removeBtn) {
        removeBtn.innerHTML = '<span class="cart-spinner"></span> Removing...';
        removeBtn.style.opacity = '0.75';
      }
      // Disable buttons to prevent duplicate triggers
      row.querySelectorAll('button').forEach(btn => btn.disabled = true);
      // Trigger smooth slide-out + collapse animation immediately
      row.classList.add('is-removing');
    }
  } else {
    if (row) {
      row.classList.add('is-updating');
      row.querySelectorAll('button').forEach(btn => btn.disabled = true);
    }
  }

  try {
    const [res] = await Promise.all([
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }),
      // Allow animation to glide smoothly before repainting the DOM
      quantity === 0 ? new Promise(resolve => setTimeout(resolve, 360)) : Promise.resolve()
    ]);

    if (!res.ok) throw new Error('Cart update failed');
    const cart = await res.json();

    // Update UI directly from change.js cart response (instant, no extra network fetch)
    updateCartUI(cart);
  } catch (err) {
    console.error('Failed to change quantity:', err);
    if (row) {
      row.classList.remove('is-removing', 'is-updating');
      row.querySelectorAll('button').forEach(btn => btn.disabled = false);
      const removeBtn = triggerBtn || row.querySelector('.cart-item-remove-btn');
      if (removeBtn) {
        removeBtn.innerHTML = 'Remove';
        removeBtn.style.opacity = '1';
      }
    }
    // Re-sync with actual state
    fetchAndUpdateCart();
  }
};

// Scroll Reveal Animations using IntersectionObserver
function initScrollAnimations() {
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (isReducedMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.scroll-reveal, .scroll-reveal-scale, .scroll-reveal-left, .scroll-reveal-right').forEach(el => {
      el.classList.add('is-revealed');
    });
    return;
  }

  // Automatic target mappings for seamless animations across all sections & pages
  const autoTargets = [
    { selector: '.showcase-banner-card', class: 'scroll-reveal-scale' },
    { selector: '.product-card-luxury', class: 'scroll-reveal-scale' },
    { selector: '.pillar-card', class: 'scroll-reveal-scale' },
    { selector: '.testimonial-card', class: 'scroll-reveal-scale' },
    { selector: '.mood-card-item', class: 'scroll-reveal-scale' },
    { selector: '.categories-grid > div', class: 'scroll-reveal-scale' },
    { selector: '.insta-grid > div', class: 'scroll-reveal-scale' },
    { selector: '.hero-copy', class: 'scroll-reveal' },
    { selector: '.hero-grid > div:last-child', class: 'scroll-reveal-scale' },
    { selector: '.story-grid > div:first-child', class: 'scroll-reveal-left' },
    { selector: '.story-grid > div:last-child', class: 'scroll-reveal-right' },
    { selector: 'section > .container-luxury > div:first-child', class: 'scroll-reveal' }
  ];

  autoTargets.forEach(({ selector, class: className }) => {
    document.querySelectorAll(selector).forEach(el => {
      if (!el.classList.contains('scroll-reveal') &&
          !el.classList.contains('scroll-reveal-scale') &&
          !el.classList.contains('scroll-reveal-left') &&
          !el.classList.contains('scroll-reveal-right')) {
        el.classList.add(className);

        // Apply progressive stagger delay for sibling cards in grids
        const siblings = el.parentElement ? Array.from(el.parentElement.children) : [];
        const index = siblings.indexOf(el);
        if (index >= 0) {
          const delay = (index % 4) * 0.12;
          el.style.transitionDelay = `${delay}s`;
        }
      }
    });
  });

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.scroll-reveal, .scroll-reveal-scale, .scroll-reveal-left, .scroll-reveal-right').forEach(el => {
    revealObserver.observe(el);
  });
}

